import { render, staticRenderFns } from "./ResetPasswordSendConfirmed.vue?vue&type=template&id=190d6d16&scoped=true"
import script from "./ResetPasswordSendConfirmed.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordSendConfirmed.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordSendConfirmed.vue?vue&type=style&index=0&id=190d6d16&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d6d16",
  null
  
)

export default component.exports